import React from "react";
import { TableHeaderColumn } from "react-bootstrap-table";
import Crud from "../Crud";

function BonusExchangeRate() {
  return (
    <Crud
      title="Exchange Rate"
      getUrl={() => "/Addons/SystemBonusSettingDetail_GetList"}
      // UPDATE
      updateUrl={() => "/Addons/SystemBonusSettingDetail_Update"}
      updateParams={({ userId }, { wagerType, pointsPerUnit }) => ({
        WagerType: wagerType,
        PointsPerUnit: pointsPerUnit,
        IdUser: Number(userId),
      })}
    >
      <TableHeaderColumn
        visible="none"
        hiddenOnInsert
        autoValue={true}
        hidden
        isKey
        dataField="wagerType"
      >
        Id
      </TableHeaderColumn>
      <TableHeaderColumn
        dataField="description"
        filter={{ type: "TextFilter", delay: 1000 }}
      >
        Wager Type
      </TableHeaderColumn>
      <TableHeaderColumn dataField="pointsPerUnit">
        Points Per Dollar
      </TableHeaderColumn>
    </Crud>
  );
}

export default BonusExchangeRate;
